import React from "react";
import { Loading } from "@alm/flow-ds/components";
import { isReady } from "../../data/app/appSelectors";
import { State } from "data";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "components/Errors/NotFound";
import DashboardRoutes from "../../Routes/DashboardRoutes";
import DashboardWrapperLayout from "components/Layouts/DashboardWrapperLayout";

function App() {
	const ready = useSelector((state: State) => isReady(state));

	if (!ready) {
		return (
			<div className="app app--loading">
				<div className="bg-overlay" />
				<Loading className="elem__loader--lg" />
			</div>
		);
	}

	return (
		<Switch>
			<Route path="/404" exact component={NotFound} />
			<Route
				path="/"
				render={() => (
					// DashboardWrapperLayout is a component that displays the
					// UI elements that should show up regardless of what page the user is on
					<DashboardWrapperLayout>
						<DashboardRoutes />
					</DashboardWrapperLayout>
				)}
			/>
		</Switch>
	);
}

export default App;
